import { render, staticRenderFns } from "./SchoolCityManageView.vue?vue&type=template&id=3495c536&scoped=true&"
import script from "./SchoolCityManageView.vue?vue&type=script&lang=js&"
export * from "./SchoolCityManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495c536",
  null
  
)

export default component.exports